import React from 'react'
import axios from 'axios'
import { businessApiURL, getCountryCode, getLanguageCode, getToken } from '../..'

export async function subscriptionPlanDetails() {
  const id = sessionStorage.getItem('id')
  try {
    const res = await axios.get(
      `${businessApiURL}/api/secure/bc/subscription/${id}?languageCode=${getLanguageCode()}&countryCode=${getCountryCode()}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      },
    )
    return res
  } catch (err) {
    console.log(err)
    return err
  }
}
